import React, { useContext, useEffect, useState } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'

const FitnessGalleriesCardModal = ({
  cancelCardModal,
  slideObj,
  addCallback,
  updateCallback,
  isEdit,
  categoryList,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { loader } = useContext(AppContext)
  const [imageS3key, setImageS3key] = useState('')
  const [heading, setHeading] = useState('')
  const [subHeading, setSubHeading] = useState('')
  const [description, setDescription] = useState('')
  const [link, setLink] = useState({
    type: '',
    data: {},
  })
  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'leftImg',
        width: 497,
        height: 410,
        divwidth: '10rem',
        divheight: '8.3rem',
        assetId: '',
        titleDisabled: true,
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
      },
    ]

    if (isEdit) {
      setImageS3key(slideObj.image_s3key)
      setHeading(slideObj.heading)
      setSubHeading(slideObj.sub_heading)
      setDescription(slideObj.description)
      setLink(slideObj.link)

      imgData[0]['assetId'] = slideObj.image_s3key
      imgData[0]['imageUrl'] = getThumbnail(
        userSessionObj?.session_data?.cf_domain_name,
        slideObj.image_s3key,
      )
    }

    setImageData(imgData)
  }, [])

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    if (link.type && !validateLink(link).isValid) {
      isFormValid = false
      temp.link = validateLink(link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      image_s3key: imageS3key,
      heading: heading,
      sub_heading: subHeading,
      description: description,
      link: link,
    }
    isEdit ? updateCallback(elementObj) : addCallback(elementObj)

    cancelCardModal()
  }
  return (
    <CModal alignment="center" scrollable size="lg" className="category-card-modal" visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalHeader
        style={{ borderBottom: 0, paddingBottom: 0 }}
        className="d-flex justify-content-center align-items-center"
      >
        <p style={{ fontSize: '20px' }}>
          <b style={{ fontWeight: '500' }}>Add/Edit carousel elements</b>
        </p>
      </CModalHeader>
      <CModalBody className="px-5 static-scrollbar-class d-flex flex-column justify-content-between align-items-around">
        <div>
          <div className="mt-2">
            <div>
              <h6 className="font-13px">
                Add image <span style={{ color: 'red' }}>*</span>
              </h6>
              <ImageUploader data={imageData} />
              <div className="message-text error-message">
                <p>{errorData.imageS3key}</p>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <h6 style={{ fontSize: '13px' }} className="">
              Heading
            </h6>
            <CustomDescriptionBox
              limit={96}
              rows={1}
              value={heading}
              onChange={(value) => setHeading(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
          <div className="mt-2">
            <h6 style={{ fontSize: '13px' }} className="">
              Sub-Heading
            </h6>
            <CustomDescriptionBox
              limit={96}
              rows={1}
              value={subHeading}
              onChange={(value) => setSubHeading(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              useFormInput={true}
            />
          </div>
          <div className="mt-2">
            <h6 style={{ fontSize: '13px' }} className="">
              Paragraph
            </h6>
            <CustomDescriptionBox
              limit={500}
              rows={3}
              value={description}
              onChange={(value) => setDescription(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-2">
            <AttachLink
              linkData={link}
              id={'attachlink'}
              categoryData={
                categoryList
                  ? categoryList.filter((info, idx) => info.type === 'category' && info.status)
                  : []
              }
              setLinkData={(value) => {
                clearError('link')
                setLink(value)
              }}
            />
          </div>
          <div className="message-text error-message">
            <p>{errorData.link}</p>
          </div>
        </div>
      </CModalBody>
      <CModalFooter style={{ borderTop: 0 }} className="px-5">
        <div className="pb-3">
          <CButton
            style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
            className="mx-4 bg-white rounded-1 btn-focus-none"
            onClick={cancelCardModal}
          >
            Cancel
          </CButton>
          <CButton
            style={{ fontSize: '1.1rem' }}
            className=" bg-black rounded-1 btn-focus-none px-3"
            onClick={handleSave}
          >
            Save
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  )
}

export default FitnessGalleriesCardModal
